import { RequestConfig } from '../../Server';
var ActionModelV5 = (function () {
    function ActionModelV5(myReceiverId, myServerEvent, controller, action, parameters, callback, highPriority, queryString) {
        if (parameters === void 0) { parameters = null; }
        if (callback === void 0) { callback = null; }
        this.myReceiverId = myReceiverId;
        this.myServerEvent = myServerEvent;
        this.controller = controller;
        this.action = action;
        this.parameters = parameters;
        this.callback = callback;
        this.requestConfig = new RequestConfig();
        this.highPriority = highPriority ? highPriority : false;
        this.queryString = queryString;
    }
    Object.defineProperty(ActionModelV5.prototype, "receiverId", {
        get: function () {
            return this.myReceiverId;
        },
        set: function (value) {
            this.myReceiverId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModelV5.prototype, "serverEvent", {
        get: function () {
            return this.myServerEvent;
        },
        enumerable: false,
        configurable: true
    });
    return ActionModelV5;
}());
export { ActionModelV5 };
